import { Button, Form, Modal, Select, Spin, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import colorsDark from '../../assets/colors/dark';
import InputTag from '../../components/InputTag';
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../constants/service.types';
import { socketEmitEvent } from '../../redux/actions';

const { Option } = Select;

const VideoInformation = ({ video, onUpdateVideoTagsSuccess, dataSelectSource, setDataSelectSource }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { namespace, updateTagsStorageFile } = useSelector((state) => state);
  const [isEditTag, setIsEditTag] = useState(false);
  const [isLoadingTag, setLoadingTag] = useState(false);

  useEffect(() => {
    if (updateTagsStorageFile) {
      onUpdateVideoTagsSuccess();
      setIsEditTag(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateTagsStorageFile]);

  useEffect(() => {
    if (video) {
      setLoadingTag(false)
    }
  }, [video]);

  const handleSaveVideoTags = ({ tags }) => {
    setLoadingTag(true)
    let data = {
      tag: tags.join(';'),
      resourceId: video.recordId,
      resource: 'storage_file',
      namespace,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_TAGS_STORAGE_FILE,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
  };

  return (
    <div>
      <div className="popover-record">
        <div className="detail">
          <div className="title">{t('Name')}:</div>
          <div className="content">{video.fileName}</div>
        </div>

        <div className="detail">
          <div className="title">{t('Recorded')}:</div>
          <div className="content">{video.recordDate}</div>
        </div>
        <div className="detail">
          <div className="title">{t('Duration')}:</div>
          <div className="content">
            {video.duration} {t('minutes')}
          </div>
        </div>

        <div className="detail">
          <div className="title">{t('Encrypt')}:</div>
          <div className="content">
            {video.encrypt === 'none' ? (
              <Tag color={colorsDark.$offline}>{t('None')}</Tag>
            ) : (
              <Tag color={colorsDark.$online}>{t('Encrypted')}</Tag>
            )}
          </div>
        </div>

        <div className="detail">
          <div className="title">{t('Data source')}:</div>
          <div className="content">
            <Select
              onChange={(value) => {
                const dataArr = dataSelectSource?.filter(item => item.id !== video?.recordId) ?? []
                setDataSelectSource([
                  ...dataArr,
                  {
                    id: video?.recordId,
                    selectRecordId: value
                  }
                ])
              }}
              size="small"
              defaultValue={video?.dataRecordIds?.[0]}
              dropdownMatchSelectWidth={false}
            >
              {video?.dataRecordIds?.map((recordId, index) => (
                <Option key={index} value={recordId}>
                  {index === 0 ? t('Main') : `${t('Replication')} ${index + 1}`}
                </Option>
              ))}
            </Select>
          </div>
        </div>

        <div className="detail">
          <div className="title">{t('Tags')}:</div>
          <div className="content" style={{ maxWidth: 300 }}>
            <Spin spinning={isLoadingTag}>
              <div className="tag-info-video">
                <InputTag
                  value={video.tags ? video.tags.split(';') : []}
                  numberTag={10}
                  onChange={(value) => handleSaveVideoTags({ tags: value })}
                />
              </div>
            </Spin>
          </div>
        </div>
        {isEditTag && (
          <Modal
            title={t('Edit tags')}
            visible={isEditTag}
            onCancel={() => setIsEditTag(false)}
            footer={[
              <Button type="text" onClick={() => setIsEditTag(false)}>
                {t('Cancel')}
              </Button>,
              <Button
                form="edit-video-tags-form"
                htmlType="submit"
                icon={<SaveOutlined />}
                type="primary"
              >
                {t('Update')}
              </Button>,
            ]}
            zIndex={1100}
          >
            <Form
              id="edit-video-tags-form"
              name="basic"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              initialValues={{ tags: video.tags ? video.tags.split(';') : [] }}
              onFinish={handleSaveVideoTags}
              autoComplete="off"
            >
              <Form.Item name="tags" wrapperCol={{ xs: 24 }}>
                <InputTag numberTag={10} />
              </Form.Item>
            </Form>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default VideoInformation;
